import styled from 'styled-components';

export {
  CardContainer,
  Header,
  IconWrapper,
  Title,
  Field,
  Label,
  Value,
} from '../shared/card-styles';

export const FieldsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
